import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-white rounded-3xl border border-background-200/70 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="lg:w-1/2">
              <div className="inline-flex items-center gap-2 bg-accent-100 text-accent-700 rounded-full px-4 py-1.5 mb-5">
                <i className="ri-shield-check-line"></i>
                <span className="text-xs font-semibold">Sicurezza</span>
              </div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-5">
                Itaobuy Spreadsheet <span className="italic">sicurezza</span>
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed mb-8">
                Prima di utilizzare qualsiasi piattaforma online è importante verificare sempre le informazioni, la privacy e l&apos;affidabilità delle fonti. La sicurezza dei tuoi dati e la qualità delle informazioni sono la nostra priorità assoluta. Ci impegniamo a fornire risorse aggiornate e verificate per aiutarti a navigare in modo più sicuro.
              </p>
              <Link
                to="/articoli/itaobuy-spreadsheet-guida-completa"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shield-line"></i>
                Scopri le misure di sicurezza
              </Link>
            </div>
            <div className="lg:w-1/2">
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-background-50 rounded-xl p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                    <i className="ri-lock-line text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-sm text-foreground-900 mb-1">Dati protetti</h4>
                  <p className="text-xs text-foreground-500">Informazioni verificate e aggiornate</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                    <i className="ri-eye-line text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-sm text-foreground-900 mb-1">Trasparenza</h4>
                  <p className="text-xs text-foreground-500">Fonti chiare e tracciabili</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                    <i className="ri-refresh-line text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-sm text-foreground-900 mb-1">Aggiornamenti</h4>
                  <p className="text-xs text-foreground-500">Contenuti sempre freschi</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                    <i className="ri-guide-line text-lg"></i>
                  </div>
                  <h4 className="font-semibold text-sm text-foreground-900 mb-1">Guide pratiche</h4>
                  <p className="text-xs text-foreground-500">Consigli utili per navigare sicuri</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}